/**
 * Custom hook for getting units and currency based on current language
 * Used in recap components and CRM to display appropriate units for weight and price
 */

import { useTranslation } from "react-i18next";
import { getWeightUnit } from "@/lib/units";
import { getCurrencySymbol } from "@/lib/currency";

export function useUnitsAndCurrency() {
  const { i18n } = useTranslation();

  // Get the current language
  const language = i18n.language || "fr";
  const isEnglish = language.startsWith("en");

  // Get units and symbols
  const weightUnit = getWeightUnit();
  const currencySymbol = getCurrencySymbol();

  // Construct combined unit for price per weight (e.g., "€/kg" or "$/lbs")
  const pricePerWeightUnit = `${currencySymbol}/${weightUnit}`;

  return {
    weightUnit,
    currencySymbol,
    pricePerWeightUnit,
    isEnglish,
  };
}
